import { getDistinctValues, groupBy, selectMany } from "@omnia/shared/utils/array";
import { defineDirective, ICrop, IOmniaSession, IUibModalScope, IVariety } from "../../../../omnia"
import { EditPlanCroppingCtrl } from "../cropping"
import { CroppingEditVm } from "../croppingEditVm"
import { isCropSupportedForNutrition } from "@omnia/shared/nutrition";

export interface ICropFilterViewModel {

    crop: ICrop,
    variety: IVariety,
    text: string

}

export class AddCroppingPopupCtrl {

    static create(): ng.IDirective {

        return defineDirective(AddCroppingPopupCtrl, "app/nutrition/plan/edit/cropping/add/popup.html", {});

    };

    private $scope: IUibModalScope;

    private ready: boolean = false;

    public filter: ICropFilterViewModel;
    public filterItems: ICropFilterViewModel[];

    private _cropping: CroppingEditVm[];
    private context: EditPlanCroppingCtrl;
    private precision: boolean;

    static $inject = ["$scope", "OmniaSession"];

    constructor($scope: ng.IScope, private session: IOmniaSession) {
        this.$scope = <IUibModalScope>$scope.$parent;

        var optionsScope = this.$scope.$parent;

        if (optionsScope && optionsScope["croppings"] && optionsScope["context"]) {
            this._cropping = optionsScope["croppings"];
            this.context = optionsScope["context"];
            this.precision = this.context.currentPlan.Precision;
            this.setupFilter();
            this.ready = true;
        }
    }

    private setupFilter() {

        var cropping = this._cropping;

        var items = cropping
            .map(c => c.croppingVm)
            .map(c => {
                return {
                    crop: c.cropping.Crop,
                    variety: c.cropping.Variety
                }
            });

        items = getDistinctValues(items, i => i, i => i.crop.CropId + ";" + (i.variety ? i.variety.CropVarietyId : 0));

        var groups = groupBy(items, i => i.crop, c => c.CropId);

        this.filterItems = selectMany(groups.map(g => {

            var items = [
                {
                    crop: g.key,
                    variety: null,
                    text: g.key.Name
                }
            ];

            return items.concat(g.values.filter(i => !!i.variety).map(i => {

                return {
                    crop: i.crop,
                    variety: i.variety,
                    text: i.crop.Name + " - " + i.variety.Name
                };

            }));

        }));

    }

    getCropping(applyFilters: boolean): CroppingEditVm[] {

        let cropping = this._cropping;

        cropping = cropping.filter(c => isCropSupportedForNutrition(c))

        if (applyFilters && this.filter) {

            cropping = cropping.filter(c => c.croppingVm.cropping.CropId == this.filter.crop.CropId);

            if (this.filter.variety) {
                cropping = cropping.filter(c => c.croppingVm.cropping.VarietyId == this.filter.variety.CropVarietyId);
            }

        }

        return cropping;

    }

    close() {
        this.$scope.$close();
    }
}
